var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { getUiOptions } from "../utils/";

var defaultProps = {
    defaultFormData: {
        _action: undefined,
        reference: {},
        referenceId: undefined,
        referenceType: undefined
    },
    defaultOptions: {
        "layout": "module",
        "editable": true,
        "hideable": true,
        "deletable": true,
        "restorable": true
    },
    defaultSchema: {
        "type": "object",
        "properties": {
            "referenceId": {
                "type": "string",
                "readonly": true
            },
            "referenceType": {
                "type": "string",
                "default": undefined,
                "readonly": true
            },
            "reference": {
                "type": "object",
                "properties": {
                    "documentType": {
                        "type": "string",
                        "default": undefined,
                        "readonly": true
                    },
                    "title": {
                        "type": "string",
                        "default": "Untitled"
                    },
                    "_action": {
                        "type": "string",
                        "readonly": true,
                        "default": "create"
                    }
                }
            },
            "_action": {
                "type": "string",
                "readonly": true,
                "default": "create"
            }
        }
    }
};

var getSchema = function getSchema(props) {
    var schema = props.schema,
        defaultSchema = props.defaultSchema;
    var documentType = schema.documentType,
        referenceType = schema.referenceType,
        _reverseReferenceType = schema._reverseReferenceType,
        _reverseReference = schema._reverseReference,
        properties = schema.properties;

    // default

    var fieldSchema = defaultSchema;

    // referenceType

    if (referenceType) {
        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, fieldSchema.properties, {
                referenceType: _extends({}, fieldSchema.properties.referenceType, {
                    default: referenceType
                })
            })
        });
    }

    // documentType

    if (documentType) {
        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, fieldSchema.properties, {
                reference: _extends({}, fieldSchema.properties.reference, {
                    properties: _extends({}, fieldSchema.properties.reference.properties, {
                        documentType: _extends({}, fieldSchema.properties.reference.properties.documentType, {
                            default: documentType
                        }),
                        title: _extends({}, fieldSchema.properties.reference.properties.title, {
                            default: "Untitled" + documentType
                        })
                    })
                })
            })
        });
    }

    // _reverseReferenceType

    if (_reverseReferenceType) {
        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, fieldSchema.properties, {
                _reverseReferenceType: {
                    "type": "string",
                    "default": _reverseReferenceType,
                    "readonly": true
                }
            })
        });
    }

    // _reverseReferenceType

    if (_reverseReference) {
        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, fieldSchema.properties, {
                _reverseReference: {
                    "type": "string",
                    "default": _reverseReference,
                    "readonly": true
                }
            })
        });
    }

    // properties

    if (properties) {
        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, defaultSchema.properties, properties)
        });
    }

    return fieldSchema;
};

function getUiSchema(props) {
    var formData = props.formData,
        schema = props.schema,
        uiSchema = props.uiSchema,
        defaultOptions = props.defaultOptions;


    var options = getUiOptions(uiSchema);

    if (!options.fieldset && schema.properties) {

        var fieldset = [];

        Object.keys(schema.properties).map(function (name) {

            var type = schema.properties[name] && schema.properties[name].type || undefined;

            if (type === "object") {
                fieldset.push(name);
            }
        });

        if (fieldset.length) {
            options.nav = true;
            options.fieldset = fieldset;
        }
    }

    return {
        "ui:options": _extends({}, defaultOptions, options, {
            "preview": formData && formData.reference
        })
    };
}

function getFormData(props) {
    var formData = props.formData,
        defaultFormData = props.defaultFormData;


    formData = _extends({}, defaultFormData, formData);

    var _formData = formData,
        _action = _formData._action,
        referenceId = _formData.referenceId,
        reference = _formData.reference;

    // if reference and no referenceId, action = "create"

    if (typeof _action === "undefined" && !referenceId && reference) {

        formData = _extends({}, formData, {
            "_action": "create",
            "reference": _extends({}, formData.reference, {
                "_action": "create"
            })
        });
    }

    return formData;
}

export default function getField(props) {

    props = _extends({}, defaultProps, props);

    var schema = getSchema(props);
    var uiSchema = getUiSchema(_extends({}, props, { schema: schema }));
    var formData = getFormData(_extends({}, props, { schema: schema, uiSchema: uiSchema }));

    return _extends({}, props, {
        schema: schema,
        uiSchema: uiSchema,
        formData: formData
    });
}